import {
  EMAIL_VALIDATION_MESSAGE,
  GENERIC_VALIDATION_MESSAGE,
  TEL_VALIDATION_MESSAGE
} from '../../blaze-plugins/shopware-fe-kp/components/constants';

const baseFields = {
  firstname: {
    fieldId: 'firstname',
    label: 'First name',
    showInForm: true,
    formFieldType: 'text',
    type: 'string',
    minLength: 1,
    errorMessage: GENERIC_VALIDATION_MESSAGE,
    isRequired: true
  },
  lastname: {
    fieldId: 'lastname',
    label: 'Last name',
    showInForm: true,
    formFieldType: 'text',
    type: 'string',
    minLength: 1,
    errorMessage: GENERIC_VALIDATION_MESSAGE,
    isRequired: true
  },
  email: {
    fieldId: 'email',
    label: 'Email address',
    showInForm: true,
    formFieldType: 'text',
    type: 'string',
    pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$',
    errorMessage: EMAIL_VALIDATION_MESSAGE,
    isRequired: true
  },
  country: {
    fieldId: 'country',
    label: 'Country',
    showInForm: true,
    formFieldType: 'select',
    type: 'string',
    errorMessage: GENERIC_VALIDATION_MESSAGE,
    isRequired: true
  },
  newsletterSignup: {
    fieldId: 'newsletterSignup',
    label: 'Newsletter',
    showInForm: true,
    formFieldType: 'checkbox',
    type: 'boolean',
    isRequired: false
  }
};

const FORM_SCHEMAS = {
  default: {
    type: 'object',
    properties: {
      ...baseFields
    }
  },

  gift_voucher: {
    type: 'object',
    properties: {
      firstname: baseFields.firstname,
      lastname: baseFields.lastname,
      email: baseFields.email,
      currency: {
        fieldId: 'currency',
        label: 'Currency',
        showInForm: true,
        formFieldType: 'select',
        type: 'string',
        options: [
          ['gbp', 'GBP'],
          ['usd', 'USD']
        ],
        value: 'gbp',
        isRequired: true
      },
      amount: {
        fieldId: 'amount',
        label: 'Amount',
        showInForm: true,
        formFieldType: 'select',
        type: 'string',
        value: '20',
        options: [
          ['20', '20'],
          ['30', '30'],
          ['50', '50'],
          ['100', '100'],
          ['150', '150']
        ],
        isRequired: true
      },
      discountCode: {
        fieldId: 'discountCode',
        label: 'Add discount code',
        showInForm: true,
        formFieldType: 'text',
        type: 'string',
        isRequired: false
      },
      newsletterSignup: baseFields.newsletterSignup
    }
  },

  koganpage_plus_trial_signup: {
    type: 'object',
    properties: {
      firstname: baseFields.firstname,
      lastname: baseFields.lastname,
      email: baseFields.email,
      jobRole: {
        fieldId: 'jobRole',
        label: 'Job role',
        showInForm: true,
        formFieldType: 'select',
        type: 'string',
        options: [
          ['', 'Please Choose'],
          ['student', 'Student'],
          ['librarian', 'Librarian'],
          ['lecturer', 'Lecturer'],
          ['administrator', 'Administrator']
        ],
        isRequired: true
      },
      university: {
        fieldId: 'university',
        label: 'University',
        showInForm: true,
        formFieldType: 'text',
        type: 'string',
        isRequired: true
      },
      country: baseFields.country,
      tel: {
        fieldId: 'tel',
        label: 'Telephone',
        showInForm: true,
        formFieldType: 'text',
        type: 'string',
        errorMessage: TEL_VALIDATION_MESSAGE,
        isRequired: false
      },
      subjectsOfInterest: {
        fieldId: 'subjectsOfInterest',
        label: 'Subjects of interest',
        showInForm: true,
        formFieldType: 'text',
        type: 'string',
        isRequired: true
      },
      newsletterSignup: baseFields.newsletterSignup
    }
  }
};

const FORM_TYPES = {
  gift_voucher: [
    'currency',
    'amount',
    'discountCode',
    'firstname',
    'lastname',
    'email',
    'country',
    'newsletterSignup'
  ],
  default: ['firstname', 'lastname', 'email', 'country', 'newsletterSignup'],
  koganpage_plus_trial_signup: [
    'firstname',
    'lastname',
    'email',
    'jobRole',
    'university',
    'tel',
    'subjectsOfInterest',
    'newsletterSignup'
  ]
};

export { FORM_SCHEMAS, FORM_TYPES };
